(function () {
  var CAROUSEL_SELECTOR = '.product-carousel-extended';

  function initCarousel(carousel) {
    var track = carousel.querySelector('.product-carousel-extended__track');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.product-carousel-extended__slide'));
    var prevBtn = carousel.querySelector('.product-carousel-extended__arrow--prev');
    var nextBtn = carousel.querySelector('.product-carousel-extended__arrow--next');
    if (!track || !slides.length) return;

    function getActiveIndex() {
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var step = slideWidth + gap;
      var index = step > 0 ? Math.round(track.scrollLeft / step) : 0;
      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function scrollToSlide(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    function scrollByDirection(direction) {
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (slideWidth + gap), behavior: 'smooth' });
    }

    function isAtStart() {
      return track.scrollLeft <= 1;
    }

    function isAtEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    var infiniteLoop = carousel.getAttribute('data-infinite-loop') === 'true';

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (infiniteLoop && isAtStart()) {
          scrollToSlide(slides.length - 1);
          return;
        }
        scrollByDirection(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (infiniteLoop && isAtEnd()) {
          scrollToSlide(0);
          return;
        }
        scrollByDirection(1);
      });
    }

    if (carousel.getAttribute('data-autoplay') === 'true') {
      var speed = parseInt(carousel.getAttribute('data-autoplay-speed'), 10) || 5000;
      var timer = setInterval(function () {
        var nextIndex = (getActiveIndex() + 1) % slides.length;
        scrollToSlide(nextIndex);
      }, speed);

      carousel.addEventListener('mouseenter', function () {
        clearInterval(timer);
      });
    }
  }

  document.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
})();
